export const AGE_RANGE = "AGE_RANGE";
export const AT_LEAST = "AT_LEAST";
export const AUTOCOMPLETE = "AUTOCOMPLETE";
export const CRP = "CRP";
export const DATE_RANGE = "DATE_RANGE";
export const DFG = "DFG";
export const DOCUMENT = "DOCUMENT";
export const ERROR = "ERROR";
export const EVENT = "EVENT";
export const EVENT_SIMPLE = "EVENT_SIMPLE";
export const LIST = "LIST";
export const PFA = "PFA";
export const RADIO = "RADIO";
export const STATIC = "STATIC";
export const SUB_SEARCH = "SEARCH";
export const TERM_DEF_DESC = "TERM_DEF_DESC";
export const TEXT = "TEXT";
export const TMP = "TMP";
export const TREE = "TREE";
